import React from 'react'

import useLeadDetail from 'hooks/use-lead-detail'
import { ContactInfo } from 'store/types/lead'
import { Lead, useAppDispatch } from 'store'
import { PopOver, PopOverItemType, MenuList } from 'components'
import useCallOptions from 'modules/Leads/LeadDetail/hooks/use-call-options'
import { OptionType } from 'components/MenuList'

type Props = {
  contactInfo?: ContactInfo
  onSelectCallLog?: () => void
  onSelectLiveCall?: (value?: ContactInfo) => void
  children?: React.ReactNode
  isMenuList?: boolean
  isPortaled?: boolean
  isDisabled?: boolean
}

const CallOptions: React.FC<Props> = ({
  contactInfo,
  onSelectCallLog,
  onSelectLiveCall,
  children,
  isMenuList,
  isPortaled = true,
  isDisabled = false,
}) => {
  const dispatch = useAppDispatch()
  const { options } = useCallOptions()
  const { leadId } = useLeadDetail()

  const handleSelect = (selected?: PopOverItemType) => {
    if (!leadId) {
      return
    }

    switch (selected?.value) {
      case 'call-log':
        dispatch(
          Lead.openCallLogWindow({
            leadId,
            contactInfo: contactInfo,
          }),
        )
        onSelectCallLog && onSelectCallLog()
        break
      case 'live-call':
        onSelectLiveCall?.(contactInfo)
        break
      default:
    }
  }

  if (isMenuList) {
    const menuOptions: OptionType[] = options.map((i) => ({
      label: i.label as string,
      value: i.value as string,
      icon: i.icon as string[],
    }))
    return <MenuList options={menuOptions} onSelect={(v) => handleSelect({ label: v, value: v })} />
  }

  return (
    <PopOver
      icon={['far', 'list']}
      title="disposition_lbl"
      options={options}
      onChange={handleSelect}
      textColor="defaultText"
      isPortaled={isPortaled}
      isDisabled={isDisabled}
    >
      {children}
    </PopOver>
  )
}

export default CallOptions
